import store from "../store";
import getDataFromUrl from "@/helpers/getDataFromUrl";

export default {
    clearFilters: function (f) {
        const newCarsStartParams = store.state.newCars.startParams;
        let res = {};
        for (let k in f) {
            if (isNaN(f[k][0])) delete f[k][0]
            if (isNaN(f[k][1])) delete f[k][1]

            if(store.state.excludeFilterParams.includes(k)){
                continue;
            }
            let item = f[k];
            /*
                        if (k == "verd") {
                            // console.log("F",f[k]);
                            if (f[k][0] == 0 && f[k][1] == 20000000) {
                                continue;
                            }
                        }

             */

            if (k === 'fuel_type' && f[k].length > 0) {
                let index = f[k].indexOf(3);
                if (index >= 0) {
                    f[k].splice(index, 1);
                }
            }

            if (k == "verd") {
                if (f[k][0] == store.state.newCarsPrice[0] && parseInt(f[k][1]) == store.state.newCarsPrice[1]) {
                    continue;
                }
            }

            const otherSliderFilters = ["affinity", "towing_capacity", "engine", "battery_capacity", "co2", "horse_power"]
            if (otherSliderFilters.includes(k)) {
                if ((!item[0] || item[0] == newCarsStartParams[k].min) && (!item[1] || parseInt(item[1]) == newCarsStartParams[k].max)) {
                    continue;
                }
            }

            if (k == "discount" && item === true) {
                res[k] = item;
                continue;
            }

            if (item.length > 0) {
                res[k] = item;
            }
        }
        return res;
    },


    setUrlParams: function (params) {
        //return '?';
        let url = "?" + new URLSearchParams(params).toString()
        return url
    },

    getParams(d, filtersClean) {
        let filter = JSON.parse(JSON.stringify(filtersClean));
        if (window.location.search.slice(1)) {
            let res = getDataFromUrl();
            for (let k in res) {
                if (k == 'affinity' || k == 'towing_capacity') {
                    filter[k] = [parseInt(res[k][0]),parseInt(res[k][1])];
                }else if (k == 'discount') {
                    if (Array.isArray(res[k])) {
                        if (res[k][0] == 'true') {
                            filter[k] = true
                        } else {
                            filter[k] = false
                        }
                    }
                } else {
                    filter[k] = res[k];
                }
            }
            /*
            window.location.search.slice(1).split("&").map(e => {
                let pa = e.split("=");
                filter[pa[0]] = pa[1].split(",");
            })*/
        }
        return filter;
    },

    find_diff: function (arr1, arr2) {
        let diff = [];
        let joined = arr1.concat(arr2);
        for (let i = 0; i <= joined.length; i++) {
            let current = joined[i];
            if (joined.indexOf(current) == joined.lastIndexOf(current)) {
                diff.push(current);
            }
        }
        return diff;
    },

    getParams22(d, filtersClean) {
        let filter = JSON.parse(JSON.stringify(filtersClean));
        if (window.location.search.slice(1)) {
            var p = window.location.search.slice(1).split("=")[0];

            if (p == 'fbclid') {
                return filter;
            }

            p = p.replace("=%3D", "");
            p = p.replace("%2F", "/");

            let f = JSON.parse(window.atob(p));

            for (var k in f) {
                let item = f[k];
                filter[k] = item;
            }

        }
        return filter;
    },

    getBrandLogo(brand) {
        if (brand) {
            return store.state.imageUrl + '/img/logos/' + brand.trim().capitalize() + '-logo.png'
        }
    },

    getCompanyImg(img_name) {
        if (img_name) {
            return store.state.imageUrl + '/img/company/' + img_name
        }
    },

    getPicUrl(img) {
        return store.state.imageUrl + '/images/' + img + '.jpg';
        /*
        var isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;

        let host = window.location.host;

        if(host == 'dev.bilaskra.is'){
            return store.state.imageUrl + '/images/' + img + '.jpg';
        }
        if (host.search("192.168") >= 0) {
            return store.state.imageUrl + '/images/' + img + '.jpg';
        }



        if (!!window.chrome || isFirefox) {
            return store.state.imageUrl + '/images/' + img + '.webp';
        }
        return store.state.imageUrl + '/images/' + img + '.jpg';
         */
    }
}
